export class InventoryAttribute {

    constructor(
    	public recid: number = null,
		public Manufacturer: string = '',
		public Model: string = '',
		public SerialNumber: string = '',
		public SerialNumber_new: string = '',
		public wwn: string = '',
		public Capacity: string = '',
		public maximumLba: string = '',
		public grade: string = '',
		public BlockSize: string = '',
		public FormFactor: string = '',
		public RPM: string = '',
		public HealthScore: string = '',
		public ReallocatedSectors: string = '',
		public smartPowerOnHours: string = '',
		public deviceSummary: string = '',
		public erasureSummary: string = '',
		public erasureMethod: string = '',
		public erasureResults: string = '',
		public erasureDuration: string = '',
		public erasureStartDate: string = '',
		public erasureStartTime: string = '',
		public erasureEndTime: string = '',
		public erasureEndDate: string = '',
		public systemSerialNumber: string = '',
		public ataVersion: string = '',
		public scsiVersion: string = '',
		public microcode: string = '',
		public poNumber: string = '',
		public systemName: string = '',
		public processingDate: string = '',
		public processingTime: string = '',
		public pxeProfile: string = '',
		public systemManufacturer: string = '',
		public systemProductName: string = '',
		public systemMac: string = '',
		public systemChassisType: string = '',
		public biosManufacturer: string = '',
		public biosDate: string = '',
		public biosVersion: string = '',
		public motherboardManufacturer: string = '',
		public motherboardModel: string = '',
		public motherboardVersion: string = '',
		public motherboardSerialNumber: string = '',
		public processorInformation: string = '',
		public processorManufacturer: string = '',
		public processorModel: string = '',
		public processorSerialNumber: string = '',
		public processorSpeed: string = '',
		public processorCores: string = '',
		public processorType: string = '',
		public memoryInformation: string = '',
		public memoryManufacturer: string = '',
		public memoryModel: string = '',
		public memorySerialNumber: string = '',
		public memorySize: string = '',
		public memorySpeed: string = '',
		public componentManufacturer: string = '',
		public componentModel: string = '',
		public componentSerialNumber: string = '',
		public batteryInformation: string = '',
		public batteryManufacturer: string = '',
		public batterySerialNumber: string = '',
		public batteryId: string = '',
		public batteryBuildDate: string = '',
		public batteryChemistry: string = '',
		public batteryCapacity: string = '',
		public batteryFullCharge: string = '',
		public batteryLife: string = '',
		public batteryGrade: string = '',
		public videoAdapter: string = '',
		public displayResolution: string = '',
		public networkAdapter: string = '',
		public opticalDevice: string = '',
		public multimedia: string = '',
		public deviceCount: string = '',
		public computraceTestResults: string = '',
		public burninInResultsCpu: string = '',
		public burninInResultsMemory: string = '',
		public systemConditionGrade: string = '',
		public missingPartsAnswer1: string = '',
		public physicalGradingAnswer2: string = '',
		public screenGradingAnswer3: string = '',
		public ataGradleFile: string = '',
		public scsiGradleFile: string = '',
		public mdm: string = '',
		public computrace: string = ''
	) {}
}